/**
 * @generated SignedSource<<0b4333c6260ab80dcf705f639a791d4c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type interiorsPhotosTracking_tradePhoto$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"getShoppablePhotoData_tradePhoto">;
  readonly " $fragmentType": "interiorsPhotosTracking_tradePhoto";
};
export type interiorsPhotosTracking_tradePhoto$key = {
  readonly " $data"?: interiorsPhotosTracking_tradePhoto$data;
  readonly " $fragmentSpreads": FragmentRefs<"interiorsPhotosTracking_tradePhoto">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "interiorsPhotosTracking_tradePhoto"
};

(node as any).hash = "eb0972b7fbcc2509032ccd25cbd4413a";

export default node;
